export const LANGUAGE_DB_KEY = 'language-1.8'
